import React from 'react'
import { getHelpQuestions } from '@verzekeringapp-mono/shared/src/models/help_question'
import HelpQuestionToggle from '../../../components/help_question_toggle'
import Modal from '../../../components/Modal'

interface IProps {
  onClose: () => void
}

const HelpModal: React.FC<IProps> = (props) => (
  <Modal onClose={props.onClose}>
    <p className='title text-center'>Help</p>

    {getHelpQuestions().map((question) => (
      <HelpQuestionToggle
        key={question.id}
        question={question}
      />
    ))}
  </Modal>
)

export default HelpModal
